// extracted by mini-css-extract-plugin
export default {"table":"Steps_table__1SvSi","stepDivider":"Steps_stepDivider__odByb"};